import {
  SmartTable,
  SmartTableColumn,
  SmartTableDataItem,
} from '@design/components/smart-table';

import styles from './SharedTable.module.scss';

export interface SharedTableProps<T> {
  tableData: SmartTableDataItem<T>[];
  tableColumns: SmartTableColumn<T>[];
  onRowClick?: (item: SmartTableDataItem<T>) => void;
}

export const SharedTable = <T extends {}>({
  tableData,
  tableColumns,
  onRowClick,
}: SharedTableProps<T>) => {
  return (
    <div className={styles.root}>
      <SmartTable
        columns={tableColumns}
        data={tableData}
        onRowClick={onRowClick}
      />
    </div>
  );
};
